import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('creditMemoReport', [booksMenu])
  .controller('creditMemoReportController', creditMemoReportController)
    .name;
    
/* @ngInject */ function creditMemoReportController($scope, $q, BooksSvc, BusyScreen, Session) {
  /*---------------------*/
  /* Generic Data Object */
  /*---------------------*/
  $scope.data = {};
  $scope.reportPage = Session.getSessionURL('/CreditMemoReport.aspx');
  
  /*--------------*/
  /* Set defaults */
  /*--------------*/
  $scope.req = { reportFormat: 'PDF', sortByDate: true, entityID: 0 };

  /*------------------------------------------------------------*/
  /* Works with the CSM validator to make sure the account      */
  /* information is populated and dates are formatted propertly */
  /*------------------------------------------------------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    return $scope.valOption.validate();
  };

  /*****************************************************************************
   * checkEntity */
  /**
   * Checks that an entity has been selected, if not the default text of
   * All Individuals will be set.
   *
   *****************************************************************************/
  $scope.checkEntity = function () {
    if ($scope.req.entityID == 0)
      angular
        .element(document.getElementById('txtIndividual'))
        .val('All Individuals');
  };

  /*****************************************************************************
   * getEntities */
  /**
   * Contact the server to load the list of entities that match the provided
   * input query.
   *
   * @param  query  Input text to look up
   * @return        Promise to listen for
   *****************************************************************************/
  $scope.getEntities = function (query) {
    var defer = $q.defer();
    BooksSvc.findEntities(query).then(function (resp) {
      defer.resolve(resp.data);
    });

    return defer.promise;
  };

  /*--------------------------------------------*/
  /* Watch when the entity model changes so the */
  /* request can be updated for the entity ID   */
  /*--------------------------------------------*/
  $scope.$watch('data.entity', function (entity) {
    $scope.req.entityID = angular.isObject(entity) ? entity.id : 0;
  });

  /*--------------*/
  /* Get services */
  /*--------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.checkEntity();
    $scope.org = resp.data;
    BusyScreen.setBusy(false);
  });
}
